import type { TenantConfiguration } from "@/types/tenants";

export const ROUTE_MOVEMENT_DATA_INBOUNDS = 'inbounds';
export const ROUTE_MOVEMENT_DATA_OUTBOUNDS = 'outbounds';
export const ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA = 'sustainabilitydata';
export const ROUTE_MOVEMENT_DATA_MASSBALANCES = 'mass-balances';
export const ROUTE_MOVEMENT_DATA_CATSCREDITS = 'catscredits';
export const ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY = 'catscreditshistory';
export const ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS = 'carbonintensityconfigurations';
export const ROUTE_MOVEMENT_DATA_CONTRACTS = 'contracts';
export const ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS = 'contract-positions';

export const ROUTE_IMPORT_MESSAGES = 'import-messages';

export const ROUTE_MASTERDATA_PARTNERS = 'partners';
export const ROUTE_MASTERDATA_FEEDSTOCK = 'feedstock';
export const ROUTE_MASTERDATA_LOCATIONS = 'locations';
export const ROUTE_MASTERDATA_PRODUCTS = 'products';
export const ROUTE_MASTERDATA_SITE_PRODUCTS = 'site-products';
export const ROUTE_MASTERDATA_PRODUCT_GROUPS = 'product-groups';
export const ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES = 'product-group-energy-densities';
export const ROUTE_MASTERDATA_COUNTRY_CODES = 'country-codes';
export const ROUTE_MASTERDATA_PROVINCE_CODES = 'province-codes';

export const ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT = 'onsite-report-facility-input';
export const ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT = 'onsite-report-facility-OUTput';
export const ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT = 'offsite-report-facility-input';
export const ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE = 'product-material-balance-report';
export const ROUTE_REPORTS_CREDIT_GENERATION = 'credit-generation-report';
export const ROUTE_REPORTS_BIOFUEL_PURCHASES = 'biofuel-purchases-report';
export const ROUTE_REPORTS_ANNUAL_CREDIT_ADJUSTMENT = 'annual-credit-adjustment';
export const ROUTE_REPORTS_STANDALONE_CREDIT_SUMMARY = 'standalone-agreement-credit-summary';
export const ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT = 'cfr-credit-reconcilation-summary-report';
export const ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT = 'cfr-bio-import-credit-report';

export const IMPORT_IMPERIAL_OIL_RAW_IMPORT = 'imperialoilRawImport';
export const IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT = 'imperialoilRawPhdImport';
export const IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT = 'imperialoilRawStockImport';
export const IMPORT_CFR_IMPORT = 'cfrImport';
export const IMPORT_CFR_HISTORY_IMPORT = 'cfrHistoryImport';

export const PREVIEW_ROUTES = [
    ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
]

export const PROTECTED_ROUTES = [
    // Movement Data
    ROUTE_MOVEMENT_DATA_INBOUNDS,
    ROUTE_MOVEMENT_DATA_OUTBOUNDS,
    ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
    ROUTE_MOVEMENT_DATA_MASSBALANCES,
    ROUTE_MOVEMENT_DATA_CATSCREDITS,
    ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY,
    ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
    ROUTE_MOVEMENT_DATA_CONTRACTS,
    ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS,

    // Import Messages
    ROUTE_IMPORT_MESSAGES,

    // Master Data
    ROUTE_MASTERDATA_PARTNERS,
    ROUTE_MASTERDATA_FEEDSTOCK,
    ROUTE_MASTERDATA_LOCATIONS,
    ROUTE_MASTERDATA_PRODUCTS,
    ROUTE_MASTERDATA_SITE_PRODUCTS,
    ROUTE_MASTERDATA_PRODUCT_GROUPS,
    ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
    ROUTE_MASTERDATA_COUNTRY_CODES,
    ROUTE_MASTERDATA_PROVINCE_CODES,

    // Reports
    ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
    ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
    ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
    ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
    ROUTE_REPORTS_CREDIT_GENERATION,
    ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
    ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT
];

export const TENANT_CONFIGS: Record<string, TenantConfiguration> = {
    TEST_CFR: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY,
            ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
            ROUTE_MOVEMENT_DATA_CONTRACTS,
            ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            ROUTE_REPORTS_CREDIT_GENERATION,
            ROUTE_REPORTS_BIOFUEL_PURCHASES,
            ROUTE_REPORTS_ANNUAL_CREDIT_ADJUSTMENT,
            ROUTE_REPORTS_STANDALONE_CREDIT_SUMMARY,
            ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
            ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
        ],
        visibleImports: [
            IMPORT_CFR_IMPORT,
            IMPORT_CFR_HISTORY_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    TEST_PRODUCER: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            // ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            // ROUTE_REPORTS_CREDIT_GENERATION,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    DOCU_CFR: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY,
            ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
            ROUTE_MOVEMENT_DATA_CONTRACTS,
            ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            ROUTE_REPORTS_CREDIT_GENERATION,
            ROUTE_REPORTS_BIOFUEL_PURCHASES,
            ROUTE_REPORTS_ANNUAL_CREDIT_ADJUSTMENT,
            ROUTE_REPORTS_STANDALONE_CREDIT_SUMMARY,
            ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
            ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
        ],
        visibleImports: [
            IMPORT_CFR_IMPORT,
            IMPORT_CFR_HISTORY_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    DOCU_PRODUCER: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            // ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            // ROUTE_REPORTS_CREDIT_GENERATION,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    EXXON_PRODUCER: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            // ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            // ROUTE_REPORTS_CREDIT_GENERATION,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    EXXON_CFR: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY,
            ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
            ROUTE_MOVEMENT_DATA_CONTRACTS,
            ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            ROUTE_REPORTS_CREDIT_GENERATION,
            ROUTE_REPORTS_BIOFUEL_PURCHASES,
            ROUTE_REPORTS_ANNUAL_CREDIT_ADJUSTMENT,
            ROUTE_REPORTS_STANDALONE_CREDIT_SUMMARY,
            ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
            ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
        ],
        visibleImports: [
            IMPORT_CFR_IMPORT,
            IMPORT_CFR_HISTORY_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    TENANT1: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            ROUTE_REPORTS_CREDIT_GENERATION,
            ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
            ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    EXXON_CO_PRO_STRCO: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            // ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            // ROUTE_REPORTS_CREDIT_GENERATION,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    EXXON_CO_PRO_NANCO: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            // ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            // ROUTE_REPORTS_CREDIT_GENERATION,
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ],
    },
    AUTOMATION_CFR: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS,
            ROUTE_MOVEMENT_DATA_CATSCREDITS_HISTORY,
            ROUTE_MOVEMENT_DATA_CARBON_INTENSITY_CONFIGURATIONS,
            ROUTE_MOVEMENT_DATA_CONTRACTS,
            ROUTE_MOVEMENT_DATA_CONTRACT_POSITIONS,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_PRODUCT_MATERIAL_BALANCE,
            ROUTE_REPORTS_CREDIT_GENERATION,
            ROUTE_REPORTS_BIOFUEL_PURCHASES,
            ROUTE_REPORTS_ANNUAL_CREDIT_ADJUSTMENT,
            ROUTE_REPORTS_STANDALONE_CREDIT_SUMMARY,
            ROUTE_CFR_CREDIT_RECONCILATION_SUMMARY_REPORT,
            ROUTE_CFR_BIO_IMPORT_CREDIT_REPORT,
        ],
        visibleImports: [
            IMPORT_CFR_IMPORT,
            IMPORT_CFR_HISTORY_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT
        ]
    },
    AUTOMATION_PRODUCER: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT
        ]
    },
    AUTOMATION_CO_PRO: {
        visibleRoutes: [
            ROUTE_MOVEMENT_DATA_INBOUNDS,
            ROUTE_MOVEMENT_DATA_OUTBOUNDS,
            ROUTE_MOVEMENT_DATA_SUSTAINABILITYDATA,
            ROUTE_MOVEMENT_DATA_MASSBALANCES,
            ROUTE_MASTERDATA_PARTNERS,
            ROUTE_MASTERDATA_PRODUCTS,
            ROUTE_MASTERDATA_PRODUCT_GROUPS,
            ROUTE_MASTERDATA_SITE_PRODUCTS,
            ROUTE_MASTERDATA_LOCATIONS,
            ROUTE_MASTERDATA_PRODUCT_GROUP_ENERGY_DENSITIES,
            ROUTE_MASTERDATA_COUNTRY_CODES,
            ROUTE_MASTERDATA_PROVINCE_CODES,
            ROUTE_IMPORT_MESSAGES,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_INPUT,
            ROUTE_REPORTS_ONSITE_REPORT_FACILITY_OUTPUT,
            ROUTE_REPORTS_OFFSITE_REPORT_FACILITY_INPUT
        ],
        visibleImports: [
            IMPORT_IMPERIAL_OIL_RAW_PHD_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_STOCK_IMPORT,
            IMPORT_IMPERIAL_OIL_RAW_IMPORT,
        ]
    }
};
TENANT_CONFIGS["EXXON_POLARIS_CFR"] = TENANT_CONFIGS["EXXON_CFR"];
TENANT_CONFIGS["EXXON_POLARIS_PRODUCER"] = TENANT_CONFIGS["EXXON_PRODUCER"];
TENANT_CONFIGS["EXXON_POLARIS_CO_PRO_NANCO"] = TENANT_CONFIGS["EXXON_CO_PRO_NANCO"];
TENANT_CONFIGS["EXXON_POLARIS_CO_PRO_STRCO"] = TENANT_CONFIGS["EXXON_CO_PRO_STRCO"];

export function isPreviewUser(login: string): boolean {
    return login.toUpperCase().endsWith('@VTA-SOFTWARE.DE') || login.toUpperCase() === 'FRUBEL';
}
